import { cn } from '@/lib/utils';
import { Eye } from 'lucide-react';

interface ViewCountProps {
  viewCount: number;
  shouldShowHoverEffects: boolean;
}

export default function ViewCount({ viewCount, shouldShowHoverEffects }: ViewCountProps) {
  return (
    <div
      className={cn(
        'absolute bottom-2 right-2 from-brand-blue via-brand-blue to-white bg-gradient-to-r text-black text-xs px-2 py-1 rounded-full flex items-center gap-1 z-10',
        'transition-all duration-500 ease-out',
        shouldShowHoverEffects ? 'opacity-100' : 'opacity-0'
      )}
    >
      <Eye className="w-4 h-4" />
      <span className="font-extrabold uppercase">
        {viewCount} {viewCount === 1 ? 'view' : 'views'}
      </span>
    </div>
  );
}
